import type {GetEntrySheetResponse} from '../../../core/repositories/reportsRepository';

export type ListSheetBaseInfo = Array<{
  label: string;
  value: string;
}>;
export const listEntrySheetBaseInfo = (
  entrySheet: GetEntrySheetResponse,
): ListSheetBaseInfo => {
  const resultNotificationMethod =
    entrySheet.fixedQuestionAnswers.resultNotificationMethod.length > 0
      ? entrySheet.fixedQuestionAnswers.resultNotificationMethod[0]?.answerLabel
      : '';
  const resultNotificationTime =
    entrySheet.fixedQuestionAnswers.resultNotificationTime.length > 0
      ? entrySheet.fixedQuestionAnswers.resultNotificationTime[0]?.answerLabel
      : '';
  const resultSubmissionMethod =
    entrySheet.fixedQuestionAnswers.submissionMethod.length > 0
      ? entrySheet.fixedQuestionAnswers.submissionMethod[0]?.answerLabel
      : '';
  const base_info_obj = {
    部門: entrySheet.department.name ?? '',
    提出期日: entrySheet.submissionDueDate ?? '',
    連絡手段: resultNotificationMethod ?? '',
    結果通知時期: resultNotificationTime ?? '',
    提出方法: resultSubmissionMethod ?? '',
    最終選考結果: entrySheet.getOffer ? '内定' : '選考落ち',
  };
  return Object.entries(base_info_obj)
    .filter((tuple) => tuple[1] !== '')
    .map(([label, value]) => ({label, value}));
};
